module.exports = __webpack_public_path__ + "img/ttf-main-1242.33ce04e2.jpg";